<div class="page-section" id="services">
  <div class="section-content">
    <h2>Services & Pricing</h2>

    <div class="services-grid">
      <div class="service-card">
        <img src="assets/images/ecr.png" />

        <div class="content">
          <h3>Graded Card Removal / Cracking the Holder</h3>
          <p>Careful removal of a previously graded card from its plastic.</p>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/images/recommendations.png" />

        <div class="content">
          <h3>Recommendations</h3>
          <!-- <p>(Formerly GSA)</p> -->
          <a
            class="primary-rounded-btn"
            href="https://storage.googleapis.com/aa-public-storage-bucket-prod/recommendations-process.pdf"
            target="_blank"
            >See Our Process</a
          >
        </div>
      </div>

      <div class="service-card">
        <img src="assets/images/submission-prep.png" />

        <div class="content">
          <h3>Submission Prep</h3>
          <p>
            As advised on a card-by-card basis during the recommendations
            process.
          </p>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/images/grading-companies.png" />

        <div class="content">
          <h3>3rd Party Submission</h3>
          <p>
            We handle the process and keep you updated through our chat app
            associated with each card.
          </p>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/images/individual-card-consult.png" />

        <div class="content">
          <h3>Individual Card(s) Consultation</h3>
          <p>$50 - 30 min video call</p>

          <a
            class="primary-rounded-btn"
            [href]="customerAppURLBase + '/register'"
            >Schedule Now</a
          >
        </div>
      </div>

      <div class="service-card">
        <img src="assets/images/collection-advice.png" />

        <div class="content">
          <h3>Collection Guidance</h3>
          <p>$150 / an hour - offered in-person only</p>

          <a
            class="primary-rounded-btn"
            [href]="customerAppURLBase + '/register'"
            >Schedule Now</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
